import { Dataset } from '../../types/types';
import { isUnformattedFloatItem } from './isUnformattedFloatItem';

// Float items with no format of their own fall back to the database default
export const applyDefaultNumberFormat = (
  dataset: Dataset,
  numberFormat: string
): Dataset => {
  if (!dataset.items) {
    return dataset;
  }

  const items = dataset.items.map((item) =>
    isUnformattedFloatItem(item) ? { ...item, format: numberFormat } : item
  );

  return { ...dataset, items };
};
